import Division from '../../../components/Division'
import FormSubmit from '../../../components/FormSubmit'
import { FORMS } from '../../../constants'
import { andWhatNext, formValidation } from '../../../helpers'
import Fragment from '../../../components/Fragment'
import queryString from 'query-string'
import { Typography } from '@material-ui/core'
import FormBase from '../../../components/FormBase'
import { StyledLinearProgress, useStyles } from './styles'

const getFormErrors = () =>
  _.omit(
    _.mapValues(FORMS.emailMp.fields, () => null),
    ['body', 'subject']
  )

const SignPetitionForm = ({ rsv, fragments, constituency, postcode }) => {
  const classes = useStyles()
  const [cookies] = useCookies()
  const [formData, setFormData] = useState({ ...FORMS.petition.fields, postcode })
  const [formErrors, setFormErrors] = useState(getFormErrors())
  const [submitted, setSubmitted] = useState(false)
  const formRefs = _.mapValues(FORMS.petition.fields, () => React.useRef())
  const petitionSignatures = parseFloat(window.ENV.PETITION_COUNT)
  const petitionGoal = parseFloat(window.ENV.PETITION_GOAL)
  const petitionPercent = (petitionSignatures / petitionGoal) * 100
  const parsed = queryString.parse(location.search)

  useEffect(() => {
    setFormData({
      ...formData,
      ..._.mapValues(
        _.pick(cookies['neu_nclb_client'], [
          'first_name',
          'last_name',
          'address',
          'email',
        ]),
        (item) => _.replace(item, /\+/g, ' ')
      ),
    })
  }, [cookies])

  const update = (prop, evt) => {
    setFormErrors(getFormErrors())
    setFormData({ ...formData, [prop]: evt.target.value })
  }

  const submit = (evt) => {
    if (!evt || !evt.key || evt.key === 'Enter') {
      const res = formValidation(formRefs, formErrors)
      if (res.valid) {
        setSubmitted(true)
      } else {
        setFormErrors(res.errors)
      }
    }
  }

  const onSuccess = () => {
    setTimeout(() => {
      window.location.href = andWhatNext('petition', {
        post: true,
        postcode: parsed.postcode,
      })
    }, 1000)
  }

  const onFail = () => {
    console.log('Failed')
  }

  const getPayload = () => ({
    petition_signature: {
      name: `${formData.first_name} ${formData.last_name}`,
      constituency_id: constituency?.id,
      ..._.pick(formData, ['email', 'opt_in']),
    },
    signup: _.pick(formData, [
      'first_name',
      'last_name',
      'email',
      'phone_number',
      'postcode',
      'union_member',
      'school_role',
      'opt_in',
    ]),
  })

  return (
    <Grid item container {...rsv} className={classes.formContainer} component="form">
      <Division padding={10} />
      {!submitted && (
        <Grid item xs={12} className={classes.sectionTitle}>
          <Typography variant="h5" align="left">
            Your details
          </Typography>
        </Grid>
      )}
      <FormSubmit
        doSubmit={submitted}
        postRoute="/api/petition-signature"
        postData={getPayload()}
        onSuccess={onSuccess}
        onFail={onFail}
        thanks={`${formData['first_name']}, thank you!`}
      />
      {!submitted && (
        <>
          <FormBase
            {...{
              exclude: { phoneNumber: true, address: true },
              formData,
              formErrors,
              formRefs,
              onChange: update,
              onSubmit: submit,
              padding: '12px 6px',
              buttonText: <Fragment title="sign_petition_button" fragments={fragments} />,
            }}
          />
        </>
      )}
    </Grid>
  )
}

export default SignPetitionForm
